import { getInstance } from './getInstance'
import { requestBody } from './requestBody'

export const amexAdapter = {
  id: 'amex',
  getInstance,
  requestBody
}
